/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverFull,
  DamageWaiverFullOptional,
  DamageWaiverFullMetaI,
  DamageWaiverFullTrackedI,
} from "./damage-waiver-full";
import {
  DamageWaiverFullTracked,
  DamageWaiverFullMeta,
} from "./damage-waiver-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverTypeRef,
  DamageWaiverTypeRefOptional,
  DamageWaiverTypeRefMetaI,
  DamageWaiverTypeRefTrackedI,
} from "./damage-waiver-type-ref";
import {
  DamageWaiverTypeRefTracked,
  DamageWaiverTypeRefMeta,
} from "./damage-waiver-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface PurchaseDamageWaiverDTO
 */
export interface PurchaseDamageWaiverDTOOptional extends DamageWaiverFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDamageWaiverDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDamageWaiverDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  waiverId?: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseDamageWaiverDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  endActive?: Date;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseDamageWaiverDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {DamageWaiverTypeRef}
   * @memberof PurchaseDamageWaiverDTO
   */
  damageWaiverTypeId?: DamageWaiverTypeRefOptional;
}

export interface PurchaseDamageWaiverDTO
  extends PurchaseDamageWaiverDTOOptional, DamageWaiverFull {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDamageWaiverDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDamageWaiverDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  waiverId: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseDamageWaiverDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  endActive?: Date;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseDamageWaiverDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {DamageWaiverTypeRef}
   * @memberof PurchaseDamageWaiverDTO
   */
  damageWaiverTypeId?: DamageWaiverTypeRef;
}

export interface PurchaseDamageWaiverDTOTrackedI extends DamageWaiverFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDamageWaiverDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDamageWaiverDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  waiverId?: number;
  waiverIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseDamageWaiverDTO
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDamageWaiverDTO
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseDamageWaiverDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseDamageWaiverDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {DamageWaiverTypeRef}
   * @memberof PurchaseDamageWaiverDTO
   */
  damageWaiverTypeId?: DamageWaiverTypeRefTrackedI;
  damageWaiverTypeIdIsSet: boolean;
}

transformDatesMap.set(
  "PurchaseDamageWaiverDTO",
  function (model: PurchaseDamageWaiverDTO) {
    if (typeof model.purchaseDate == "string")
      model.purchaseDate = new Date(model.purchaseDate);
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatesdamageWaiverTypeId = transformDatesMap.get(
      "DamageWaiverTypeRef",
    );
    if (transformDatesdamageWaiverTypeId && model.damageWaiverTypeId) {
      transformDatesdamageWaiverTypeId(model.damageWaiverTypeId);
    }
  },
);

export type PurchaseDamageWaiverDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  waiverId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  damageWaiverTypeId: PropertyMeta<DamageWaiverTypeRefMetaI>;
}>;

export var PurchaseDamageWaiverDTOMeta: PurchaseDamageWaiverDTOMetaI =
  {} as PurchaseDamageWaiverDTOMetaI;
PurchaseDamageWaiverDTOMeta = typeMeta("PurchaseDamageWaiverDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  waiverId: propertyMeta("waiverId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  damageWaiverTypeId: propertyMeta(
    "damageWaiverTypeId",
    false,
    false,
    false,
    DamageWaiverTypeRefMeta,
  ),
});

const metaI = PurchaseDamageWaiverDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DamageWaiverFullMeta]);
  metaI.isDeleted.inheritedFrom = DamageWaiverFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = DamageWaiverFullMeta.isNew;
  metaI.waiverId.inheritedFrom = DamageWaiverFullMeta.waiverId;
  metaI.price.inheritedFrom = DamageWaiverFullMeta.price;
  metaI.purchasableState.inheritedFrom = DamageWaiverFullMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = DamageWaiverFullMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = DamageWaiverFullMeta.voidCloseId;
  metaI.startActive.inheritedFrom = DamageWaiverFullMeta.startActive;
  metaI.endActive.inheritedFrom = DamageWaiverFullMeta.endActive;
  metaI.personId.inheritedFrom = DamageWaiverFullMeta.personId;
  metaI.damageWaiverTypeId.inheritedFrom =
    DamageWaiverFullMeta.damageWaiverTypeId;
});

export class PurchaseDamageWaiverDTOTracked
  extends DamageWaiverFullTracked
  implements PurchaseDamageWaiverDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  waiverId__I?: number = undefined;

  get waiverIdIsSet() {
    return this.waiverId !== undefined;
  }
  set waiverIdIsSet(v: boolean) {}
  set waiverId(v: undefined | number) {
    if (v !== undefined) {
      this.waiverId__I = v;
      this.waiverIdIsSet = true;
    } else {
      this.waiverId__I = v || undefined;
      this.waiverIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get waiverId() {
    return this.waiverId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  damageWaiverTypeId__I?: DamageWaiverTypeRefTracked = undefined;
  damageWaiverTypeIdIsSet: boolean = false;
  set damageWaiverTypeId(v: undefined | DamageWaiverTypeRefTracked) {
    if (v !== undefined) {
      this.damageWaiverTypeId__I = v;
      this.damageWaiverTypeIdIsSet = true;
    } else {
      this.damageWaiverTypeId__I = v || undefined;
      this.damageWaiverTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get damageWaiverTypeId() {
    return this.damageWaiverTypeId__I;
  }
  constructor(
    config?: PurchaseDamageWaiverDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.waiverIdIsSet == true && other?.waiverIdIsSet == true)
      return this.waiverId == other.waiverId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.waiverId) {
      this.waiverIdIsSet = true;
    }

    this.personId?.setIds();

    this.damageWaiverTypeId?.setIds();
  }
  assignFrom(
    config: PurchaseDamageWaiverDTOOptional,
    options?: AssignOptions,
  ): PurchaseDamageWaiverDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.waiverId && this.waiverIdApplyFilter(optionsRequired.filter)) {
      this.waiverId = config.waiverId;
      if (optionsRequired.unassign) this.waiverIdIsSet = false;
      else this.waiverIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.damageWaiverTypeId &&
      this.damageWaiverTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.damageWaiverTypeId = new DamageWaiverTypeRefTracked(
        config.damageWaiverTypeId,
        options,
      );
      if (optionsRequired.unassign) this.damageWaiverTypeIdIsSet = false;
      else this.damageWaiverTypeIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PurchaseDamageWaiverDTOTrackedI {
    const cloned = {} as PurchaseDamageWaiverDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.waiverIdIsSetDeep() &&
      this.waiverIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.waiverIdIsSet = true;
      cloned.waiverId = this.waiverId;
    } else {
      //cloned.waiverIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.damageWaiverTypeIdIsSetDeep() &&
      this.damageWaiverTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.damageWaiverTypeIdIsSet = true;
      cloned.damageWaiverTypeId = this.damageWaiverTypeId?.removeUnset(filter);
    } else {
      //cloned.damageWaiverTypeIdIsSet = false
    }
    if (!isDeleted(this) && !this.waiverIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PurchaseDamageWaiverDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.waiverIdApplyFilter(filter)) this.waiverIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.damageWaiverTypeIdApplyFilter(filter))
      this.damageWaiverTypeIdIsSet = false;
    this.damageWaiverTypeId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.isDeleted,
      PurchaseDamageWaiverDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.isNew,
      PurchaseDamageWaiverDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  waiverIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.waiverId,
      PurchaseDamageWaiverDTOMeta,
      this.waiverId,
      this,
    );
  }
  waiverIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.waiverIdIsSet && this.waiverIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.price,
      PurchaseDamageWaiverDTOMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.purchasableState,
      PurchaseDamageWaiverDTOMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.purchaseDate,
      PurchaseDamageWaiverDTOMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.voidCloseId,
      PurchaseDamageWaiverDTOMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.startActive,
      PurchaseDamageWaiverDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.endActive,
      PurchaseDamageWaiverDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.personId,
      PurchaseDamageWaiverDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  damageWaiverTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDamageWaiverDTOMeta.damageWaiverTypeId,
      PurchaseDamageWaiverDTOMeta,
      this.damageWaiverTypeId,
      this,
    );
  }
  damageWaiverTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.damageWaiverTypeIdIsSet &&
      this.damageWaiverTypeIdApplyFilter(filter)
    )
      return true;
    return this.damageWaiverTypeId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.waiverIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.damageWaiverTypeIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
